/**
 * Load the source for Commentary WebComponent, which is used in the Comments drawer
 *
 * @param document - the DOM document, injected rather than pulled via Angular just to keep this code vanilla
 */
export function loadCommentaryScript(document: Document) {
  const now = Date.now()
  const jsPath = '/plugin/commentary-ui/commentary-ui.js'
  const script = document.getElementById('commentaryUrl')
  script?.setAttribute('src', `${jsPath}?v=${now}`)
}
